export const testAnalyserNodeGetFloatTimeDomainDataMethodSupport = nativeAnalyserNode => {
  return typeof nativeAnalyserNode.getFloatTimeDomainData === 'function';
};